import { useStore } from "../../app/stores/store";
import BindTable from "./BindTable";
import { Form, Input, Segment } from "semantic-ui-react";
import { useEffect, useState } from "react";
import './styles.css';
import { defaultRow } from "./smarttrackerType";

export default function SmarttrackerComponents() {
    const { TrackingReportStore,userStore:{user} } = useStore();
    const { bindComponent } = TrackingReportStore;
    const [inputField,SetInputField] = useState({
      input:'',output:'',employeeName:'',reelName:'',  shortName:'',startFrame:'',
      endFrame:'',totalFrame:'',frrInformation:'',
    })  
  useEffect(()=>{
    SetInputField({
      ...inputField,
      input : bindComponent.inputPath || '',
      output: bindComponent.outputPath || '',
      employeeName: bindComponent.employeeName || '',
      frrInformation: bindComponent.frrInformation || ''
    })
        // eslint-disable-next-line
  },[bindComponent.inputPath,bindComponent.outputPath,bindComponent.employeeName,bindComponent.frrInformation])
  
  const rejectHistoryArr = bindComponent.rejectHistory.length === 0 ? defaultRow : bindComponent.rejectHistory;
    const dataChange = (data:any,name:string)=>{
      SetInputField({
        ...inputField,
        [name] : data.value,
      })
      TrackingReportStore.inputoutputHandler(data.value,name)
    }
    return (
      <Segment>
  <div className="smartrackerinputs">
  <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
    <Form.Field
      required={true}
      control={Input}
      value={inputField.input}
      placeholder={'Please enter an input path'}
      label={'Input Path'}
      disabled={false}
      onChange={(e: any, data: any) => dataChange(data, 'input')}
    />
    <Form.Field
      required={true}
      control={Input}
      value={inputField.output}
      placeholder={'Please enter an output path'}
      label={'Output Path'}
      disabled={false}
      onChange={(e: any, data: any) => dataChange(data, 'output')}
    />
    <Form.Field
      required={true}
      control={Input}
      value={inputField.employeeName}
      placeholder={'Please enter an Operator name'}
      label={'Operator Name'}
      readOnly
      onChange={(e: any, data: any) => dataChange(data, 'Operator')}
    />
  </div>
  <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
    <Form.Field
      required={true}
      control={Input}
      value={bindComponent.reelName}
      placeholder={'Please enter a reelName name'}
      label={'Reel Name'}
      readOnly
    />
    <Form.Field
      required={true}
      control={Input}
      value={bindComponent.shortName}
      placeholder={'Please enter a shortName name'}
      label={'Shot Name'}
      readOnly
    />
    <Form.Field
      required={true}
      control={Input}
      value={bindComponent.startFrame}
      placeholder={'Please enter a starFrame name'}
      label={'Start Frame'}
      readOnly
    />
  </div>
  <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
    <Form.Field
      required={true}
      control={Input}
      value={bindComponent.endFrame}
      placeholder={'Please enter an endFrame name'}
      label={'End Frame'}
      readOnly
   />
    <Form.Field
      required={true}
      control={Input}
      value={bindComponent.totalFrame}
      placeholder={'Please enter a totalFrame name'}
      label={'Total Frame'}
      readOnly
    />
     
    <Form.Field
      required={true}
      control={Input}
      value={inputField.frrInformation}
      placeholder={'Please enter a FRR Information'}
      label={'FRR Information'}
      disabled={false}
      onChange={(e: any, data: any) => dataChange(data,'frrInformation')}
    />
  </div>
</div>
        <div
          className="dynamicRowTable"
          style={{ justifyContent: 'center', padding: '15px' }}
        > 
           <div className="dynamic-Table" style={{ padding: '15px', width: '100%' }}>
            <BindTable rejectHistoryArr={rejectHistoryArr || []} addRows={user?.roleName !== 'Operator' && TrackingReportStore.bindComponent.status !== 'Yet_to_Start'} />
          </div>
          
        </div>
      </Segment>
    );
}
